import { Flex } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { RunHistorySidebar } from '@/pages/Run/components/RunHistorySidebar/RunHistorySidebar.tsx';
import { useAutomation } from '@/context/AutomationContext/useAutomationContext.ts';
import AutomationPageWrapper from '@/layouts/AutomationPageWrapper/AutomationPageWrapper.tsx';
import { useResizeObserver } from '@mantine/hooks';
import { useEffect, useMemo, useState } from 'react';
import { RunHistoryResizeHandle } from '@/pages/Run/components/RunHistorySidebar/RunHistoryResizeHandle.tsx';
import {
  clampRunHistorySidebarWidth,
  DEFAULT_RUN_HISTORY_SIDEBAR_WIDTH,
  getRunHistorySidebarMaximumWidth,
  MIN_RUN_HISTORY_SIDEBAR_WIDTH,
} from '@/pages/Run/components/RunHistorySidebar/runHistorySidebarSizing.ts';
import { LEFT_BOX_SHADOW } from '@/utils/constants.ts';

const RunsLayout = () => {
  const automation = useAutomation();
  const [runHistoryCollapsed, setRunHistoryCollapsed] = useState(false);
  const [runHistoryWidth, setRunHistoryWidth] = useState(DEFAULT_RUN_HISTORY_SIDEBAR_WIDTH);
  const [layoutRef, layoutRect] = useResizeObserver<HTMLDivElement>();

  const maximumRunHistoryWidth = useMemo(
    () => getRunHistorySidebarMaximumWidth(layoutRect.width),
    [layoutRect.width],
  );

  useEffect(() => {
    setRunHistoryWidth((currentWidth) =>
      clampRunHistorySidebarWidth(
        currentWidth,
        MIN_RUN_HISTORY_SIDEBAR_WIDTH,
        maximumRunHistoryWidth,
      ),
    );
  }, [maximumRunHistoryWidth]);

  return (
    <AutomationPageWrapper automation={automation}>
      <Flex ref={layoutRef} w="100%" h="100%" style={{ minWidth: 0, minHeight: 0 }}>
        <RunHistorySidebar
          automation={automation}
          width={runHistoryWidth}
          collapsed={runHistoryCollapsed}
          onCollapsedChange={setRunHistoryCollapsed}
        />
        {!runHistoryCollapsed && (
          <RunHistoryResizeHandle
            width={runHistoryWidth}
            minimumWidth={MIN_RUN_HISTORY_SIDEBAR_WIDTH}
            maximumWidth={maximumRunHistoryWidth}
            onWidthChange={setRunHistoryWidth}
          />
        )}
        <Flex
          h="100%"
          style={{
            boxShadow: runHistoryCollapsed ? 'none' : LEFT_BOX_SHADOW,
            flex: 1,
            minWidth: 0,
            minHeight: 0,
          }}
        >
          <Outlet />
        </Flex>
      </Flex>
    </AutomationPageWrapper>
  );
};

export default RunsLayout;
